import type { FC } from 'react';

import { useGetRiskById } from '@/hooks/queries';
type Props = {
  riskId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ riskId }) => {
  if (!riskId) {
    throw new Error('Missing riskId param');
  }
  const { data } = useGetRiskById(riskId);

  return <>{data?.risk?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
